import React from "react";
import "./About.css";
import { useCountUp } from "./hooks";
import aboutJpg from "./assets/about-photo.jpg";
import aboutWebp from "./assets/about-photo.webp";

function Stat({ end, suffix, label }) {
  const [ref, value] = useCountUp(end);
  return (
    <div className="stat">
      <h3 ref={ref}>
        {value}
        {suffix}
      </h3>
      <p>{label}</p>
    </div>
  );
}

const principles = [
  {
    n: "01",
    title: "Component-driven UI",
    text: "Reusable, well-structured React components with hooks, state management and clean architecture.",
  },
  {
    n: "02",
    title: "Pixel-perfect & responsive",
    text: "Interfaces that look right and feel right on every screen, from phones to wide desktops.",
  },
  {
    n: "03",
    title: "Fast & accessible",
    text: "Performance-minded builds with semantic markup, keyboard support and smooth interactions.",
  },
  {
    n: "04",
    title: "Full stack when needed",
    text: "Comfortable wiring up REST APIs and building Java Spring Boot and MySQL backends end to end.",
  },
];

const About = () => {
  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="about-top">
          <figure className="polaroid tilt reveal">
            <i className="tape" />
            <div className="polaroid-img">
              <picture>
                <source srcSet={aboutWebp} type="image/webp" />
                <img src={aboutJpg} alt="Portrait of Kiran Sable, React developer in Pune" width="720" height="720" loading="lazy" decoding="async" />
              </picture>
            </div>
            <figcaption>Kiran Sable · React Dev</figcaption>
          </figure>
          <div className="about-title">
            <span className="section-tag reveal">About me</span>
            <h2 className="section-title reveal" style={{ "--d": "80ms" }}>
              A React developer who <em>cares</em> about the details
            </h2>
          </div>
          <div className="about-copy">
            <p className="reveal" style={{ "--d": "120ms" }}>
              I'm <strong>Kiran Sable</strong>, a frontend-focused developer
              based in Pune. I love building clean, interactive and
              user-friendly interfaces with React.js, and I bring ideas to life
              from the first wireframe to the deployed product. I'm available for freelance projects and full-time roles.
            </p>
            <p className="reveal" style={{ "--d": "180ms" }}>
              With a Java Full Stack background, I can also build the APIs and
              databases behind the UI, which makes collaboration with backend
              teams smooth and my frontends better connected.
            </p>
          </div>
        </div>

        <div className="stats reveal">
          <Stat end={2} suffix="+" label="Years experience" />
          <Stat end={5} suffix="+" label="Projects built" />
          <Stat end={10} suffix="+" label="Technologies" />
          <Stat end={100} suffix="%" label="Passion to learn" />
        </div>

        <div className="principles">
          {principles.map((p, i) => (
            <div className="card principle reveal" key={p.n} style={{ "--d": `${i * 80}ms` }}>
              <span>{p.n}</span>
              <h4>{p.title}</h4>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
